import { Card, CardBody, CardFooter, Col } from "reactstrap";
import { H5, H6, P } from "../../../AbstractElements";
import { BerlinTheme } from "../../../Constants/Constants";
import { InfoColorData } from "../../../Data/BonusUi/BasicCard";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const InfoColorCard = () => {
  return (
    <>
      {InfoColorData.map((data, index) => (
        <Col xl="4" sm="6" key={index}>
          <Card className="height-equal">
            <CommonCardHeader headClass={`pb-20 ${data.headerClass}`} title={data.title} tagClass={data.headingClass} />
            <CardBody className={data.bodyClass}>
              <H5 className={`pb-2 ${data.textClass ? data.textClass : ""}`}> {data.text} </H5>
              <P className="mb-0">{data.span}</P>
            </CardBody>
            <CardFooter className={data.footerClass}>
              <H6 className={`"mb-0 text-end ${data.footerTextClass ? data.footerTextClass : ""}`}>{BerlinTheme}</H6>
            </CardFooter>
          </Card>
        </Col>
      ))}
    </>
  );
};
export default InfoColorCard;
